const SAVED_STATE = 'SAVED_STATE-';

export const saveStateToStorage = (corpKey, history, future) => {
  const serializedState = JSON.stringify({ history, future });
  console.log('saving state to storage');
  localStorage.setItem(SAVED_STATE + corpKey.toUpperCase(), serializedState);
};

export const loadStateFromStorage = (corpKey) => {
  const serializedState = localStorage.getItem(
    SAVED_STATE + corpKey.toUpperCase()
  );
  if (serializedState === null) {
    return null;
  }

  return JSON.parse(serializedState);
};

export const clearStateFromStorage = (corpKey = '') => {
  if (corpKey === '') return;
  localStorage.removeItem(SAVED_STATE + corpKey.toUpperCase());
};
